import React, { useCallback } from 'react';
import { View } from 'react-native';

import { InputCurrency, InputNumber } from '../../components/input';
import { useForm } from '../../../common/utils/hooks';
import { Picker, Text } from '../../components';
import { PrimaryButton } from '../../design/components';
import useDialogSaveButton from '../../hooks/useDialogSaveButton';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const timeUnits = [
	{ label: 'Minutes', value: 'minutes' },
	{ label: 'Hours', value: 'hours' },
	{ label: 'Days', value: 'days' },
];

const TicketListItemCostsFields = ({ item, modifyItem }) => {
	const styles = useThemedStyles(createStyles);
	const { values, changeFormValue } = useForm(item);

	const handleOnChange = useCallback((field) => (value) => {
		changeFormValue({ [field]: value });
	}, [changeFormValue]);

	const onSave = useCallback(async () => {
		const {
			timeSpent, timeSpentUnit, labourCost, partsCost,
		} = values;

		if (item.timeSpent !== timeSpent ||
			item.timeSpentUnit !== timeSpentUnit ||
			item.labourCost !== labourCost ||
			item.partsCost !== partsCost
		) {
			await modifyItem({
				id: item.id,
				timeSpent,
				timeSpentUnit,
				labourCost,
				partsCost,
			});
		}
	}, [values, item, modifyItem]);

	const { isSaveButtonPressed, onSaveButtonPress } = useDialogSaveButton(onSave);

	return (
		<View style={styles.form}>
			<View style={styles.field}>
				<Text style={styles.label}>Time spent</Text>
				<View style={styles.ticketInputsLine}>
					<InputNumber
						style={styles.ticketInputTimeSpent}
						multiplyByHundred={false}
						decimalPlaces={0}
						field="timeSpent"
						value={values.timeSpent}
						onChange={handleOnChange('timeSpent')}
					/>
					<View style={styles.unitPicker}>
						<Picker
							options={timeUnits}
							selectedValue={values.timeSpentUnit}
							onValueChange={handleOnChange('timeSpentUnit')}
							styles={{}}
						/>
					</View>
				</View>
			</View>

			<View style={styles.field}>
				<Text style={styles.label}>Labour cost</Text>
				<InputCurrency
					style={styles.ticketInput}
					value={values.labourCost}
					onChange={handleOnChange('labourCost')}
				/>
			</View>

			<View style={styles.field}>
				<Text style={styles.label}>Parts cost</Text>
				<InputCurrency
					style={styles.ticketInput}
					value={values.partsCost}
					onChange={handleOnChange('partsCost')}
				/>
			</View>
			<PrimaryButton
				label="Save"
				onPress={onSaveButtonPress}
				loading={isSaveButtonPressed}
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	form: {
		gap: space.lg,
	},
	field: {
		gap: 6,
	},
	label: {
		...type.secondarySemibold,
		color: colors.text,
	},
	ticketInput: {
		width: '100%',
	},
	ticketInputTimeSpent: {
		flex: 1,
		textAlign: 'left',
	},
	ticketInputsLine: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.sm,
	},
	unitPicker: {
		width: 150,
	},
});

export default TicketListItemCostsFields;
